<div class="page gray-font-color font-family bodyBackground residence-history">
  <div class="header-navigation-back">
    <mat-icon (click)="goBack()" data-test="back-arrow-icon" data-testid="back-arrow-icon">arrow_back</mat-icon>
    <span class="title">Residence History</span>
  </div>
  <div *ngIf="!isContentReady" class="skeleton-container">
    <app-skeleton-emp-residence-history isResidenceHistory="true"></app-skeleton-emp-residence-history>
  </div>
  <div *ngIf="isContentReady">
    <div [ngClass]="showHideAddButton() ? 'content' : 'content-overflow'" >
      <div class="description-banner">
        <div class="description" *ngIf="showAddNewCurrentText">
          <span class="light-font-weight"> Please update your current address.</span>
        </div>
        <div class="description" *ngIf="!driver.residenceHistoryRequirementsCompleted && !showAddNewCurrentText">
          <span>Enter the addresses of where you have lived since</span><span class="bold-text"> last 3
            years</span>,<span> without any gaps.</span>
        </div>
        <div class="description" *ngIf="driver.residenceHistoryRequirementsCompleted">
          <span>Your addresses of where you have lived for</span><span class="bold-text"> last 3 years</span>
        </div>
      </div>

      <div class="progress-bar-container">
        <mat-progress-bar mode="determinate" [value]="progressBarValue"></mat-progress-bar>
      </div>

      <div class="progress-bar-text">
        <div class="past-date-text bold-text">{{ lastMonthYear }}</div>
        <div class="current-date-text bold-text">{{ currentMonthYear }}</div>
      </div>

      <div class="addresses-container"
        [ngClass]="addresses?.length ? 'show-element' : 'hide-element'">
        <mat-error *ngIf="errorMessage" class="error padding-left-md">
          {{ errorMessage }}
        </mat-error>
        <div class="add-new">
          <p *ngIf="showAddNewCurrentText" (click)="onAddNewCurrentAddressText()">Add Current Address HERE</p>
        </div>

        <div *ngFor="let address of displayAddresses; let index = index" >
          <div class="add-current-address">
            <button mat-raised-button color="primary" class="btn-add-previous"
              *ngIf="address?.isCurrentAddress && address?.livedFromDate" (click)="onAddNewCurrentAddress(true, index)"
              data-test="add-icon" data-testid="add-current-address">Update Current Address</button>
          </div>
          <div  class="item-address"
            [ngClass]="(!address?.livedFromDate || address?.isGap) ? 'missing-data' : 'item-address'"
            [attr.data-testid]="'residency-' + address?.streetAddress?.toLowerCase()">
            <div style="display: flex; justify-content: space-between; align-items: center;">
              <div *ngIf="!address?.isCurrentAddress && address?.livedFromDate && !address?.isGap" class="title-header">
                {{ address?.livedFromDate | date: 'MMM yyyy' }} - {{ address?.livedToDate | date: 'MMM yyyy' }}
              </div>
              <div *ngIf="address?.isCurrentAddress && !address?.isGap" class="title-header">
                {{ address?.livedFromDate | date: 'MMM yyyy' }} - Current
              </div>
              <div *ngIf="address?.isGap || !address?.livedFromDate" class="missing-info">
                <div class="title-header-missing">Missing Data</div>
                <div class="missing-date-range" *ngIf="getMissingDateRange(address, index)">
                  {{ getMissingDateRange(address, index) }}
                </div>
                <div class="missing-description">
                  Please add your residence information for this period
                </div>
              </div>

              <div class="edit-icon-container">
                <mat-icon svgIcon="edit-black" *ngIf="address?.livedFromDate && !address?.isGap" class="edit-pencil-icon"
                  (click)="editIconClicked(address, index)"
                  [attr.data-testid]="address?.streetAddress?.toLowerCase() + '-editBtn'"
                  data-test="edit-button"
                  title="Edit Address"></mat-icon>
                <mat-icon *ngIf="canDeleteAddress(address, index)" 
                  class="delete-icon"
                  (click)="deleteAddress(address, index)"
                  [attr.data-testid]="address?.streetAddress?.toLowerCase() + '-deleteBtn'"
                  data-test="delete-button"
                  title="Delete Address">delete</mat-icon>
                <!-- <mat-icon *ngIf="address?.isCurrentAddress && address?.livedFromDate" svgIcon="add-plus-icon"
                  class="add-plus-icon" (click)="onAddNewCurrentAddress(true, index)" data-test="add-icon"></mat-icon> -->
                <mat-icon *ngIf="!address?.livedFromDate || address?.isGap" svgIcon="add-plus-icon" class="add-plus-icon"
                  (click)="addPreviousAddress(index)"></mat-icon>
              </div>
            </div>
            <div>
              <div class="address-text">{{ address?.streetAddress }} {{ address?.city }}</div>
            </div>
          </div>

          <div  [ngClass]="
              isCurrentAddressEdit && !isPreviousAddress && index == currentIndex ? 'show-element' : 'hide-element'
            ">
            <div [formGroup]="form">
              <ng-container *ngTemplateOutlet="
                  currentAddress;
                  context: {
                    form: form,
                    index: index
                  }
                "></ng-container>
            </div>
          </div>

          <div [ngClass]="isPreviousAddress && index == currentIndex ? 'show-element' : 'hide-element'">
            <div [formGroup]="previousAddressForm">
              <ng-container *ngTemplateOutlet="
                  previousAddress;
                  context: {
                    previousAddressForm: previousAddressForm,
                    index: index
                  }
                "></ng-container>
            </div>
          </div>
        </div>
      </div>

      <div [ngClass]="isCurrentAddressEdit && !isPreviousAddress && currentIndex == -1 ? 'show-element' : 'hide-element'">
        <div [formGroup]="form">
          <ng-container *ngTemplateOutlet="
              currentAddress;
              context: {
                form: form,
                index: -1
              }
            "></ng-container>
        </div>
      </div>

      <div  [ngClass]="isPreviousAddress && currentIndex == -2 ? 'show-element' : 'hide-element'">
        <div [formGroup]="previousAddressForm">
          <ng-container *ngTemplateOutlet="
              previousAddress;
              context: {
                previousAddressForm: previousAddressForm,
                index: -2
              }
            "></ng-container>
        </div>
      </div>

      <ng-container *ngIf="showHideAddButton()">
        <div  class="button-container" *ngIf="!isLessThan3years && !isCurrentAddressNotPresent">
          <button mat-raised-button class="btn-add-previous" [disabled]="loading" [class.save-disabled]="loading"
            (click)="navigateToPreviousAddressForm()" data-test="add-previous-address">
            <span>Add Previous Address</span>
          </button>
        </div>

        <div  class="button-container" *ngIf="isCurrentAddressNotPresent">
          <button mat-raised-button class="btn-add-previous" [disabled]="loading" [class.save-disabled]="loading"
            (click)="onAddNewCurrentAddress(true, -1)" data-testid="add-current-address"
            data-test="add-current-address">
            <span>Add Current Address</span>
          </button>
        </div>
      </ng-container>
    </div>
  </div>
</div>

<ng-template #currentAddress let-formGroup="form" let-index="index">
  <div [formGroup]="form">
    <div class="custom-expansion-panel" *ngIf="isCurrentAddressEdit">
      <div class="custom-expansion-header required-header" data-testid="panelHeader">
        <div class="panel-title" data-testid="panelTitle">{{ editFormTitle }}</div>
        <div class="panel-actions">
          <button mat-button class="btn-save" (click)="onCurrentAddressSave()" [disabled]="!form.valid || loading"
            data-test="save-button" [attr.data-testid]="'currentAddress-saveBtn' + index">
            Save
          </button>
          <button mat-button class="btn-cancel" [disabled]="addresses?.length > 0 && !isCurrentAddressValid"
            (click)="onCancelCurrentAddress()">
            Cancel
          </button>
        </div>
      </div>
      <div class="address-fields" >
        <div>
          <mat-checkbox
            class="address-lookup-toggle"
            [checked]="!isGoogleAddressLookupEnabled"
            (change)="onGoogleAddressLookupToggle($event, index)"
            data-testid="google-address-lookup-toggle">
            Enter address from outside Canada or USA
          </mat-checkbox>
          <ng-container *ngIf="isGoogleAddressLookupEnabled; else manualCurrentAddressFields">
            <mat-form-field class="full-width" appearance="outline">
              <mat-label>ADDRESS</mat-label>
              <input matInput id="addressText{{ index }}" formControlName="completeAddress" data-test="address"
                data-testid="address" required autocomplete="off" autocorrect="off" autocapitalize="off" 
                spellcheck="false" #addressInput />
              <mat-error *ngIf="form.get('completeAddress')?.touched && form.get('completeAddress')?.invalid">
                You must enter a value
              </mat-error>
            </mat-form-field>
          </ng-container>
          <!-- Manual address input template kept but unused
          <ng-template #manualAddressInput>
            <mat-form-field class="full-width" appearance="outline">
              <mat-label>ADDRESS</mat-label>
              <input matInput id="addressText{{ index }}" formControlName="streetAddress" data-test="address"
                data-testid="address" required autocomplete="off" />
              <mat-error *ngIf="form.get('streetAddress')?.touched && form.get('streetAddress')?.invalid">
                {{ getStreetAddressErrorMessage() }}
              </mat-error>
            </mat-form-field>
          </ng-template>
          -->
        </div>
        <ng-template #manualCurrentAddressFields>
          <div class="form-field-container">
            <mat-form-field class="full-width" appearance="outline">
              <mat-label>ADDRESS</mat-label>
              <input matInput id="addressText{{ index }}" formControlName="streetAddress" data-test="address"
                data-testid="address" required autocomplete="off" autocorrect="off" autocapitalize="off" 
                spellcheck="false" />
              <mat-error *ngIf="form.get('streetAddress')?.touched && form.get('streetAddress')?.invalid">
                {{ getStreetAddressErrorMessage() }}
              </mat-error>
            </mat-form-field>
          </div>
          <div class="form-field-container">
            <mat-form-field class="full-width" appearance="outline" data-testid="curr-select-country">
              <mat-label>COUNTRY</mat-label>
              <mat-select formControlName="country" (selectionChange)="onCountryChange('form', 'state')">
                <mat-option *ngFor="let country of countries" [value]="country.value" data-test="cur-country-name"
                  [attr.data-testid]="'country-' + country?.key?.toLowerCase()">
                  {{ country.key }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="form.get('country')?.touched && form.get('country')?.invalid">
                {{ getCountryErrorMessage() }}
              </mat-error>
            </mat-form-field>
          </div>
          <div class="form-field-container">
            <mat-form-field class="full-width" appearance="outline" data-testid="state">
              <mat-label>STATE / PROVINCE</mat-label>
              <mat-select formControlName="state"
                *ngIf="country && country.value && ['US', 'CA'].includes(country.value.toUpperCase()); else stateInput"
                data-test="state">
                <mat-option value="">Select province</mat-option>
                <ng-container *ngIf="
                    (country && country.value && country.value == 'Canada') || country.value == 'CA';
                    else usaOptions
                  ">
                  <mat-option *ngFor="let province of canadaProvinces" [value]="province.value"
                    [attr.data-testid]="'province-' + province?.value?.toLowerCase()">{{
                    province.name
                    }}</mat-option>
                </ng-container>
                <ng-template #usaOptions>
                  <mat-option *ngFor="let province of usaProvinces" [value]="province.value"
                    [attr.data-testid]="'provinceUS-' + province?.value?.toLowerCase()">{{
                    province.name
                    }}</mat-option>
                </ng-template>
              </mat-select>
              <mat-error *ngIf="form.get('state')?.touched && form.get('state')?.invalid">
                {{ getStateAddressErrorMessage() }}
              </mat-error>
              <ng-template #stateInput>
                <input matInput formControlName="state" data-test="state" data-testid="state-input" />
              </ng-template>
            </mat-form-field>
          </div>
          <div class="form-field-container">
            <mat-form-field class="full-width" appearance="outline">
              <mat-label>CITY</mat-label>
              <input matInput formControlName="city" data-testid="city" />
              <mat-error *ngIf="form.get('city')?.touched && form.get('city')?.invalid">
                {{ getCityAddressErrorMessage() }}
              </mat-error>
            </mat-form-field>
          </div>
          <div class="form-field-container">
            <mat-form-field class="full-width" appearance="outline">
              <mat-label>ZIPCODE / POSTAL CODE</mat-label>
              <input matInput formControlName="zipCode" inputmode="numeric" data-test="zip-code" data-testid="zip-code" />
              <mat-error *ngIf="form.get('zipCode')?.touched && form.get('zipCode')?.invalid">
                {{ getZipcodeErrorMessage() }}
              </mat-error>
            </mat-form-field>
          </div>
        </ng-template>
        <div class="form-field-container" *ngIf="minFromDate">
          <div class="date-selector-row">
            <mat-form-field class="half-width" appearance="outline">
              <mat-label>FROM MONTH</mat-label>
              <mat-select formControlName="fromMonth" data-testid="from-month">
                <mat-option *ngFor="let month of getAvailableFromMonths()" [value]="month.value">
                  {{ month.name }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="form.get('fromMonth')?.touched && form.get('fromMonth')?.invalid">
                Month is required
              </mat-error>
            </mat-form-field>
            
            <mat-form-field class="half-width" appearance="outline">
              <mat-label>FROM YEAR</mat-label>
              <mat-select formControlName="fromYear" data-testid="from-year">
                <mat-option *ngFor="let year of getAvailableFromYears()" [value]="year">
                  {{ year }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="form.get('fromYear')?.touched && form.get('fromYear')?.invalid">
                Year is required
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="form-field-container" *ngIf="maxFromDate">
          <div class="date-selector-row">
            <!-- Show text for current addresses, dropdowns for previous addresses -->
            <ng-container *ngIf="shouldDisableToDate; else showToDateDropdowns">
              <div class="half-width current-address-date-display">
                <label class="date-label">TO MONTH</label>
                <div class="date-value">{{ getCurrentMonthName() }}</div>
              </div>
              
              <div class="half-width current-address-date-display">
                <label class="date-label">TO YEAR</label>
                <div class="date-value">{{ getCurrentYear() }}</div>
              </div>
            </ng-container>
            
            <ng-template #showToDateDropdowns>
              <mat-form-field class="half-width" appearance="outline">
                <mat-label>TO MONTH</mat-label>
                <mat-select formControlName="toMonth" data-testid="to-month">
                  <mat-option *ngFor="let month of getAvailableToMonths()" [value]="month.value">
                    {{ month.name }}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="form.get('toMonth')?.touched && form.get('toMonth')?.invalid">
                  Month is required
                </mat-error>
              </mat-form-field>
              
              <mat-form-field class="half-width" appearance="outline">
                <mat-label>TO YEAR</mat-label>
                <mat-select formControlName="toYear" data-testid="to-year">
                  <mat-option *ngFor="let year of getAvailableToYears()" [value]="year">
                    {{ year }}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="form.get('toYear')?.touched && form.get('toYear')?.invalid">
                  Year is required
                </mat-error>
              </mat-form-field>
            </ng-template>
          </div>
        </div>
        <div class="form-bottom-actions">
          <button mat-raised-button class="btn-save" (click)="onCurrentAddressSave()" [disabled]="!form.valid || loading"
            data-testid="currentAddress-bottomSaveBtn">
            Save
          </button>
          <button mat-button class="btn-cancel" [disabled]="addresses?.length > 0 && !isCurrentAddressValid"
            (click)="onCancelCurrentAddress()">
            Cancel
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #previousAddress let-formGroup="previousAddressForm" let-index="index">
  <div [formGroup]="previousAddressForm">
    <div class="custom-expansion-panel" *ngIf="isPreviousAddress">
      <div class="custom-expansion-header required-header">
        <div class="panel-title">Previous Address</div>
      </div>
      <div class="address-fields" >
        <div>
          <div class="form-field-container">
            <mat-checkbox
              class="address-lookup-toggle"
              [checked]="turnOffAddressLookup"
              (change)="onPreviousAddressLookupCheckboxToggle($event)"
              data-testid="google-address-lookup-toggle">
              Enter address from outside Canada or USA
            </mat-checkbox>
          </div>
          <div class="form-field-container" *ngIf="!turnOffAddressLookup; else manualAddress">
            <mat-form-field class="full-width" appearance="outline">
              <mat-label>ADDRESS</mat-label>
              <input matInput id="previousAddressText{{ index }}" formControlName="fullAddress" 
                autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false" />
              <mat-error *ngIf="previousAddressForm.get('fullAddress')?.touched && previousAddressForm.get('fullAddress')?.invalid">
                {{ getFullAddressErrorMessage() }}
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <ng-template #manualAddress>
          <div *ngIf="turnOffAddressLookup">
            <div class="form-field-container">
              <mat-form-field class="full-width" appearance="outline">
                <mat-label>ADDRESS</mat-label>
                <input matInput formControlName="previousAddress" />
                <mat-error *ngIf="previousAddressForm.get('previousAddress')?.touched && previousAddressForm.get('previousAddress')?.invalid">
                  {{ getPreviousAddressErrorMessage() }}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="form-field-container">
              <mat-form-field class="full-width" appearance="outline">
                <mat-label>COUNTRY</mat-label>
                <mat-select formControlName="previousAddressCountry"
                  (selectionChange)="onCountryChange('previousAddressForm', 'previousAddressState')"
                  data-test="pre-select-country">
                  <mat-option *ngFor="let country of countries" [value]="country.value" data-test="pre-country-name">
                    {{ country.key }}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="previousAddressForm.get('previousAddressCountry')?.touched && previousAddressForm.get('previousAddressCountry')?.invalid">
                  {{ getPreviousAddressCountryErrorMessage() }}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="form-field-container">
              <mat-form-field class="full-width" appearance="outline">
                <mat-label>STATE / PROVINCE</mat-label>
                <mat-select #previousStateSelect (focus)="onSelectFocus(previousStateSelect)"
                  formControlName="previousAddressState" *ngIf="
                    previousAddressCountry &&
                      previousAddressCountry.value &&
                      ['US', 'CA'].includes(previousAddressCountry.value.toUpperCase());
                    else PreviousAddressStateInput
                  " data-testid="select-province">
                  <mat-option value="">Select province</mat-option>
                  <ng-container *ngIf="
                      (previousAddressCountry &&
                        previousAddressCountry.value &&
                        previousAddressCountry.value == 'Canada') ||
                        previousAddressCountry.value == 'CA';
                      else usaOptions
                    ">
                    <mat-option *ngFor="let province of canadaProvinces" [value]="province.value"
                      [attr.data-testid]="'province-' + province?.value?.toLowerCase()">{{
                      province.name
                      }}</mat-option>
                  </ng-container>
                  <ng-template #usaOptions>
                    <mat-option *ngFor="let province of usaProvinces" [value]="province.value"
                      [attr.data-testid]="'provinceUS-' + province?.value?.toLowerCase()">{{
                      province.name
                      }}</mat-option>
                  </ng-template>
                </mat-select>
                <mat-error *ngIf="previousAddressForm.get('previousAddressCity')?.touched && previousAddressForm.get('previousAddressCity')?.invalid">
                  {{ getPreviousAddressCityErrorMessage() }}
                </mat-error>
                <ng-template #PreviousAddressStateInput>
                  <input matInput formControlName="previousAddressState" />
                </ng-template>
              </mat-form-field>
            </div>
            <div class="form-field-container">
              <mat-form-field class="full-width" appearance="outline">
                <mat-label>CITY</mat-label>
                <input matInput formControlName="previousAddressCity" data-testid="city" />
                <mat-error *ngIf="previousAddressForm.get('previousAddressCity')?.touched && previousAddressForm.get('previousAddressCity')?.invalid">
                  {{ getPreviousAddressCityErrorMessage() }}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="form-field-container">
              <mat-form-field class="full-width" appearance="outline">
                <mat-label>ZIPCODE / POSTAL CODE</mat-label>
                <input matInput formControlName="previousAddressZipCode" inputmode="numeric" data-testid="zipcode" />
                <mat-error *ngIf="previousAddressForm.get('previousAddressZipCode')?.touched && previousAddressForm.get('previousAddressZipCode')?.invalid">
                  {{ getPreviousAddressZipCodeErrorMessage() }}
                </mat-error>
              </mat-form-field>
            </div>
          </div>
        </ng-template>
        <div class="form-field-container" *ngIf="minFromDate">
          <div class="date-selector-row">
            <mat-form-field class="half-width" appearance="outline">
              <mat-label>FROM MONTH</mat-label>
              <mat-select formControlName="previousFromMonth" data-testid="previous-from-month">
                <mat-option *ngFor="let month of getPreviousAvailableFromMonths()" [value]="month.value">
                  {{ month.name }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="previousAddressForm.get('previousFromMonth')?.touched && previousAddressForm.get('previousFromMonth')?.invalid">
                Month is required
              </mat-error>
            </mat-form-field>
            
            <mat-form-field class="half-width" appearance="outline">
              <mat-label>FROM YEAR</mat-label>
              <mat-select formControlName="previousFromYear" data-testid="previous-from-year">
                <mat-option *ngFor="let year of getPreviousAvailableFromYears()" [value]="year">
                  {{ year }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="previousAddressForm.get('previousFromYear')?.touched && previousAddressForm.get('previousFromYear')?.invalid">
                Year is required
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="form-field-container" *ngIf="maxFromDate">
          <div class="date-selector-row">
            <mat-form-field class="half-width" appearance="outline">
              <mat-label>TO MONTH</mat-label>
              <mat-select formControlName="previousToMonth" data-testid="previous-to-month">
                <mat-option *ngFor="let month of getPreviousAvailableToMonths()" [value]="month.value">
                  {{ month.name }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="previousAddressForm.get('previousToMonth')?.touched && previousAddressForm.get('previousToMonth')?.invalid">
                Month is required
              </mat-error>
            </mat-form-field>
            
            <mat-form-field class="half-width" appearance="outline">
              <mat-label>TO YEAR</mat-label>
              <mat-select formControlName="previousToYear" data-testid="previous-to-year">
                <mat-option *ngFor="let year of getPreviousAvailableToYears()" [value]="year">
                  {{ year }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="previousAddressForm.get('previousToYear')?.touched && previousAddressForm.get('previousToYear')?.invalid">
                Year is required
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="form-bottom-actions">
          <button mat-raised-button class="btn-save" (click)="onAddPreviousAddress()"
            [disabled]="!previousAddressForm.valid || loading" data-testid="previousAddress-bottomSaveBtn">
            Save
          </button>
          <button mat-button class="btn-cancel" (click)="cancelPreviousAddressForm()">
            Cancel
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-template>